const configuration = {
    significantEvents : [
        { name : 'Goal' },
        { name : 'OwnGoal', postfix : '(OG)' }
    ]
}

export default configuration;